import { Check, Minus } from 'lucide-react';
import { Checkbox as C } from 'radix-ui';
import { type ReactNode, useId } from 'react';
import { cx } from '@/lib/cx';
import s from './Checkbox.module.css';

export interface CheckboxProps {
  checked: boolean | 'indeterminate';
  onChange: (checked: boolean) => void;
  label?: ReactNode;
  'aria-label'?: string;
  disabled?: boolean;
  className?: string;
}

export function Checkbox({ checked, onChange, label, disabled, className, ...aria }: CheckboxProps) {
  const id = useId();
  const box = (
    <C.Root
      id={id}
      checked={checked}
      onCheckedChange={(v) => onChange(v === true)}
      disabled={disabled}
      className={s.box}
      onClick={(e) => e.stopPropagation()}
      {...aria}
    >
      <C.Indicator className={s.indicator}>{checked === 'indeterminate' ? <Minus aria-hidden /> : <Check aria-hidden />}</C.Indicator>
    </C.Root>
  );
  if (!label) return box;
  return (
    <span className={cx(s.row, className)}>
      {box}
      <label htmlFor={id} className={s.label}>
        {label}
      </label>
    </span>
  );
}
